import { Component, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { Stormpath } from '../stormpath/stormpath.service';
export var ForgotPasswordComponent = (function () {
    function ForgotPasswordComponent(stormpath) {
        this.stormpath = stormpath;
        this.sent = false;
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        this.forgotPasswordFormModel = {
            email: ''
        };
    };
    ForgotPasswordComponent.prototype.send = function () {
        var _this = this;
        this.error = null;
        this.stormpath.sendPasswordResetEmail(this.forgotPasswordFormModel)
            .subscribe(function () { return _this.sent = true; }, function (error) { return _this.error = error.message; });
    };
    ForgotPasswordComponent.prototype.onSubmit = function (form) {
        this.send();
    };
    ForgotPasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'forgot-password-form',
                    template: "<template #defaultTemplate>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <p *ngIf=\"sent\" class=\"alert alert-success\">\n        We have sent a password reset link to the email address of the account that you specified.\n        Please check your email for this message, then click on the link.\n      </p>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <form class=\"form-horizontal\" *ngIf=\"!sent\" #form=\"ngForm\" (ngSubmit)=\"onSubmit(form.value)\" autocomplete=\"off\">\n        <div class=\"form-group\">\n          <label for=\"spEmail\" class=\"col-sm-3 control-label\">Email</label>\n          <div class=\"col-sm-9\">\n            <input class=\"form-control\" name=\"email\" type=\"email\" id=\"spEmail\" [(ngModel)]=\"forgotPasswordFormModel.email\"\n                   placeholder=\"Your Email Address\" [disabled]=\"posting\" required>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-offset-3\">\n            <p class=\"text-danger\" *ngIf=\"error\">{{error}}</p>\n            <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"posting\">Request Password Reset</button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</template>\n<template\n  [ngTemplateOutlet]=\"customTemplate || defaultTemplate\">\n</template>"
                },] },
        { type: Injectable },
    ];
    /** @nocollapse */
    ForgotPasswordComponent.ctorParameters = function () { return [
        { type: Stormpath, },
    ]; };
    ForgotPasswordComponent.propDecorators = {
        'customTemplate': [{ type: Input },],
    };
    return ForgotPasswordComponent;
}());
//# sourceMappingURL=forgot-password.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/forgot-password/forgot-password.component.js
// module id = 568
// module chunks = 0